import { IChartData } from "../interfaces";

export const PHASE_UNIT_CODE = 133;

export const isPhaseSeries = (s: IChartData) => String(s.unitCode) === String(PHASE_UNIT_CODE);

export const findPairedSeries = (series: IChartData, all: IChartData[]): IChartData | undefined =>
  all.find(s => s.idPoint === series.idPoint && isPhaseSeries(s) !== isPhaseSeries(series));

export const splitAmplitudePhase = (data: IChartData[]) => ({
  amplitudeCharts: data.filter(s => !isPhaseSeries(s)),
  phaseCharts: data.filter(isPhaseSeries),
});
